import React from "react";
import { Helmet } from "react-helmet";
import DefaultHelmetMeta from "../../../components/DefaultHelmetMeta";

const EmptyProfileHelmet = () => (
  <Helmet>
    <title>Casemasters</title>
    <DefaultHelmetMeta />
  </Helmet>
);

export default EmptyProfileHelmet;



// WEBPACK FOOTER //
// ./src/scenes/OthersProfile/components/EmptyProfileHelmet.js